import { CircleAlert, AlertTriangle, Truck, ShieldCheck } from "lucide-react";
import { number, money, date } from "./purchase-order-presentation";
import type { PurchaseOrdersViewState } from "./purchase-order-view-state";

type Props = Pick<PurchaseOrdersViewState,
  | "filter"
  | "setFilter"
  | "isQuality"
  | "dataLoaded"
  | "metrics"
  | "isSpecialist"
  | "candidates"
  | "setOperationError"
  | "setDialog">;

export function PurchaseOrdersOperations({
  filter,
  setFilter,
  isQuality,
  dataLoaded,
  metrics,
  isSpecialist,
  candidates,
  setOperationError,
  setDialog,
}: Props) {
  return (<>
    <section
      className="purchase-order-operations"
      aria-label="Sipariş görünümü"
    >
      <button
        type="button"
        aria-pressed={filter === "ACTION"}
        className={filter === "ACTION" ? "is-selected" : ""}
        onClick={() => setFilter("ACTION")}
      >
        <span>
          <CircleAlert size={16} />{" "}
          {isQuality ? "Kalite bekleyen" : "Sıradaki işler"}
        </span>
        <strong>{dataLoaded ? metrics.action : "Doğrulanmadı"}</strong>
      </button>
      <button
        type="button"
        aria-pressed={filter === "RISK"}
        className={`${metrics.risk ? "is-risk" : ""} ${filter === "RISK" ? "is-selected" : ""}`.trim()}
        onClick={() => setFilter("RISK")}
      >
        <span>
          <AlertTriangle size={16} /> Müdahale gereken
        </span>
        <strong>{dataLoaded ? metrics.risk : "Doğrulanmadı"}</strong>
      </button>
      <button
        type="button"
        aria-pressed={filter === "MOVING"}
        className={filter === "MOVING" ? "is-selected" : ""}
        onClick={() => setFilter("MOVING")}
      >
        <span>
          <Truck size={16} /> Teslimat sürecinde
        </span>
        <strong>{dataLoaded ? metrics.moving : "Doğrulanmadı"}</strong>
      </button>
      <button
        type="button"
        aria-pressed={filter === "RESULT"}
        className={filter === "RESULT" ? "is-selected" : ""}
        onClick={() => setFilter("RESULT")}
      >
        <span>
          <ShieldCheck size={16} /> Sonuçlanan
        </span>
        <strong>{dataLoaded ? metrics.result : "Doğrulanmadı"}</strong>
      </button>
    </section>
    {filter === "ACTION" && isSpecialist && candidates.length > 0 ? (
      <section className="purchase-order-candidates">
        <div>
          <strong>{candidates.length} nihai karar sipariş bekliyor</strong>
          <span>Tedarikçiye iletmeden önce ticari özeti doğrulayın.</span>
        </div>
        <div>
          {candidates.map((candidate) => (
            <article
              key={candidate.requestNo}
              className="purchase-order-candidate-row"
            >
              <div>
                <small>
                  {candidate.requestNo} · Sipariş oluşturulmayı bekliyor
                </small>
                <strong>{candidate.requestTitle}</strong>
                <span>
                  {number(candidate.quantity)} {candidate.unit} ·{" "}
                  {candidate.supplierName} · {candidate.offerNo}
                </span>
              </div>
              <div>
                <small>Birim fiyat</small>
                <strong>
                  {money(candidate.unitPrice, candidate.currency)}
                </strong>
                <span>
                  Toplam {money(candidate.amount, candidate.currency)}
                </span>
              </div>
              <div>
                <small>Karar</small>
                <strong>{candidate.decidedBy}</strong>
                <span>{date(candidate.decidedAt)}</span>
              </div>
              <button
                className="primary-button"
                onClick={() => {
                  setOperationError("");
                  setDialog({ kind: "create", candidate });
                }}
              >
                Sipariş oluştur
              </button>
            </article>
          ))}
        </div>
      </section>
    ) : null}
  </>);
}
